var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('text-row',{attrs:{"row-id":_vm.attr.id,"row-class":_vm.attr.rowClass,"icon-show":_vm.attr.iconShow,"icon-class":_vm.attr.class,"icon-name":_vm.attr.iconName,"text-class":_vm.attr.textClass,"text-value":_vm.attr.value}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }